import { Injectable } from "@angular/core";

@Injectable()
export class HeaderService {

  constructor() {
  }

  public showHeader(show: boolean) {
    const bannerWrapper = document.querySelector('.global-header');
    //need to find a fix adding "!"
    if (show) {
      bannerWrapper!.classList.remove('animateOut');
      bannerWrapper!.classList.add('animateIn');
    }
    else {
      bannerWrapper!.classList.remove('animateIn');
      bannerWrapper!.classList.add('animateOut');
    }

  }
}
